import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { themes } from '@/themes'
import {config} from  './env.config'

Vue.use(Vuetify)

const selectedTheme = config.theme ? config.theme.toLowerCase() : 'osigu'
const themeConfiguration = themes[selectedTheme]

const themeInstance = new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        ...themeConfiguration.colors
      }
    }
  },
  icons: {
    values: {
      ...themeConfiguration.icons
    }
  }
})

export default themeInstance;
